import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { HrDashboardService } from '../../../services/hr-dashboard.service';
import { TenantRouterService } from '../../../services/tenant-router.service';

@Component({
  selector: 'app-pulse-score-widget',
  standalone:false,
  templateUrl: './pulse-score-widget.component.html',
  styleUrl: './pulse-score-widget.component.scss'
})

export class PulseScoreWidgetComponent implements OnChanges {
  pulseScore: { name: string; value: number }[] = [];
  entityType = 'tenant'; // Could be 'tenant', 'team', etc.
  @Input() entityId!: number; 

  colorScheme: Color = {
    name: 'customScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#2F80ED', '#E0E0E0']
  };

  constructor(private hrDashboardService: HrDashboardService,
    private tenantRouter : TenantRouterService
  ) {}

 ngOnChanges(): void {
    if (this.entityId) {
    this.loadPulseScore();
  }
}

  loadPulseScore(): void {
    this.hrDashboardService.getEntityPulseScore(this.entityType,this.entityId).subscribe({
      next: (data) => {
        const score = Math.round(data.scorePercentage);
        this.pulseScore = [
          { name: 'Score', value: score },
          { name: 'Remaining', value: 100 - score }
        ];
      },
      error: (err) => console.error('Failed to load pulse score', err)
    });
  }

  getHierarchy() {
  if (this.entityId) {
    this.tenantRouter.navigate(['hierarchy', this.entityId]);
  }
}

}


